"use client";

import type { ReactNode } from "react";
import { DatadogUserContext } from "@/components/datadog-user-context";
import { ThemeProvider } from "@/components/theme-provider";
import { isPublicSandboxAuthEnabled } from "@/lib/auth/sandbox";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider defaultTheme="light" enableSystem={false}>
      {isPublicSandboxAuthEnabled() ? null : <DatadogUserContext />}
      {children}
    </ThemeProvider>
  );
}
